module.exports = __webpack_public_path__ + "static/media/19-12.d5743399.mp3";